module.exports = __webpack_public_path__ + "static/img/bann.c9ae486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bann.png
// module id = 3MWB
// module chunks = 1